var map = {
	"./mini-bau.png": 485,
	"./mini-ca.png": 7620,
	"./mini-cua.png": 84,
	"./mini-ga.png": 433,
	"./mini-nai.png": 1014,
	"./mini-tom.png": 6433
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6132;